import { Injectable } from '@angular/core';
import { CommonService } from '../../shared/services/common.service';

export interface ApiErrorPayload {
  status: number;
  message: string;
  data?: any;
}

@Injectable({
  providedIn: 'root'
})
export class ExceptionHandlerService {
  // Only care about business status 1004 for now
  private readonly displayStatusCodes = new Set<number>([1004]);

  constructor(private commonSvc: CommonService) { }

  handleHttpError(error: ApiErrorPayload | null | undefined): void {
    if (!error) {
      return;
    }

    const { status, message } = error;

    if (this.displayStatusCodes.has(status)) {
      console.log('Business error:', message);
      this.commonSvc.message.error(message || 'Something went wrong please contact support.');
      throw error;
    }

    if (status !== 200 && status != null) {
      this.commonSvc.message.error(message || `Error code: ${status}`);
      throw error;
    }
  }
}

